import IInitializableModule from '@episerver/spa-core/Core/IInitializableModule';
import IServiceContainer from '@episerver/spa-core/Core/IServiceContainer';
import IEpiserverContext from '@episerver/spa-core/Core/IEpiserverContext';
import IStateReducerInfo from '@episerver/spa-core/Core/IStateReducerInfo';
import LocalCellularTroubleshootingWizardBlockSlice from './LocalCellularTroubleshootingWizardBlockSlice';

export default class LocalCellularTroubleshootingWizardInitializableModule implements IInitializableModule {
  protected name: string = 'LocalCellularTroubleshootingWizard module';

  public GetName(): string {
    return this.name;
  }

  public ConfigureContainer(container: IServiceContainer): void {
  }

  public StartModule(context: IEpiserverContext): void {
  }

  public GetStateReducer(): IStateReducerInfo<any> | null {
    return {
      stateKey: 'localCellularTroubleshootingWizardBlock',
      reducer: LocalCellularTroubleshootingWizardBlockSlice,
    };
  }
}
